import { Locale } from '@yi/core';

export const i18nPhrases = {
  loving_yoga_international_articles: (locale: Locale) => {
    const en = 'Loving Yoga International articles?';
    const phrases: { [key: string]: undefined | string } = {
      en,
      es: `¿Te gustan los artículos de Yoga Internacional?`,
    };
    return phrases[locale] || en;
  },
  no_credit_card_required: (locale: Locale) => {
    const en = 'No credit card required.';
    const phrases: { [key: string]: undefined | string } = {
      en,
      es: `No se requiere tarjeta de crédito`,
    };
    return phrases[locale] || en;
  },
  continue_reading: (locale: Locale) => {
    const en = 'Continue Reading';
    const phrases: { [key: string]: undefined | string } = {
      en,
      es: `Seguir leyendo`,
    };
    return phrases[locale] || en;
  },
  you_ve_reached_your_limit: (
    locale: Locale,
    {
      transformFn,
    }: {
      transformFn: React.FC<{ text: string }>;
    },
  ) => {
    const en = (
      <>
        You’ve reached your limit. Create a {transformFn({ text: 'free account' })} and gain access
        to our entire article library.
      </>
    );
    const phrases: { [key: string]: undefined | React.ReactNode } = {
      en,
      es: (
        <>
          Has llegado a tu límite. Crea una {transformFn({ text: 'cuenta gratuita' })} y accede a
          toda nuestra biblioteca de artículos.
        </>
      ),
    };
    return phrases[locale] || en;
  },
};
